import axios from '../../v2/app/services/axiosService';
import {isObject} from 'lodash';

export default {
  getTeamTypes() { // MLD-6463
    return [
      {id: 'Customer', name: 'Customer',},
      {id: 'Partner', name: 'Partner',},
      {id: 'Demo', name: 'Demo',},
    ]
  },
  async getCurrentTeams() { // MLD-7272
    const response = await axios.get(`/api/user/teams`);
    return response.data;
  },
  getDefaultPromptForTimeoutMinutes() { // MLD-4249
    if (isObject(window.ML) && window.ML.default_prompt_for_customer_timeout_minutes) {
      return window.ML.default_prompt_for_customer_timeout_minutes;
    } else if (isObject(window.config) && window.config.default_prompt_for_customer_timeout_minutes) {
      return window.config.default_prompt_for_customer_timeout_minutes;
    }
    return 10;
  },
  async get(teamID) {
    const response = await axios.get(`/api/teams/${teamID}`);
    return response.data;
  },
  async create(form) {
    const response = await axios.post(`/api/teams`, form);
    return response.data;
  },
  async update(teamID, form) {
    const response = await axios.put(`/api/admin/teams/${teamID}`, form);
    return response.data;
  },
  activateAllUsersGroup() {
    return axios.post(`/api/teams`)
  }
}
